/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface XPTransactionHistoryResponsePagination
 */
export interface XPTransactionHistoryResponsePagination {
    /**
     * Total number of transactions
     * @type {number}
     * @memberof XPTransactionHistoryResponsePagination
     */
    total?: number;
    /**
     * Number of transactions per page
     * @type {number}
     * @memberof XPTransactionHistoryResponsePagination
     */
    limit?: number;
    /**
     * Starting offset
     * @type {number}
     * @memberof XPTransactionHistoryResponsePagination
     */
    offset?: number;
    /**
     * Whether more transactions exist
     * @type {boolean}
     * @memberof XPTransactionHistoryResponsePagination
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the XPTransactionHistoryResponsePagination interface.
 */
export function instanceOfXPTransactionHistoryResponsePagination(value: object): value is XPTransactionHistoryResponsePagination {
    return true;
}

export function XPTransactionHistoryResponsePaginationFromJSON(json: any): XPTransactionHistoryResponsePagination {
    return XPTransactionHistoryResponsePaginationFromJSONTyped(json, false);
}

export function XPTransactionHistoryResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): XPTransactionHistoryResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function XPTransactionHistoryResponsePaginationToJSON(json: any): XPTransactionHistoryResponsePagination {
    return XPTransactionHistoryResponsePaginationToJSONTyped(json, false);
}

export function XPTransactionHistoryResponsePaginationToJSONTyped(value?: XPTransactionHistoryResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'hasMore': value['hasMore'],
    };
}

